import { render, staticRenderFns } from "./snackbars.vue?vue&type=template&id=fcabf2f0&scoped=true&lang=pug"
import script from "./snackbars.vue?vue&type=script&lang=js"
export * from "./snackbars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcabf2f0",
  null
  
)

export default component.exports